import { memo, useMemo } from 'react';

import PropTypes from 'prop-types';

import GameItem from 'components/pages/Analytics/GamesByRetention/GamesList/GameItem/GameItem';

import styles from './GamesList.module.scss';

const GamesList = ({ games }) => {
  const gamesJSX = useMemo(
    () =>
      games?.map(({ gameName, icon, backgroundColor }, index) => (
        <GameItem
          key={gameName}
          order={index + 1}
          gameName={gameName}
          icon={icon}
          backgroundColor={backgroundColor}
        />
      )),
    [games],
  );

  return <div className={styles.wrapper}>{gamesJSX}</div>;
};

GamesList.propTypes = {
  games: PropTypes.arrayOf(
    PropTypes.shape({
      gameName: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      percentage: PropTypes.number.isRequired,
      backgroundColor: PropTypes.string,
    }),
  ).isRequired,
};

export default memo(GamesList);
